require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-pain-vs-suffering-an-open-letter-from-code-fellows-python-instructor.json") })
        }
      }, "path---blog-pain-vs-suffering-an-open-letter-from-code-fellows-python-instructor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-pain-vs-suffering-an-open-letter-from-code-fellows-python-instructor!./.cache/json/blog-pain-vs-suffering-an-open-letter-from-code-fellows-python-instructor.json
// module id = 1009
// module chunks = 231608221292675